export default {
  welcome: 'Bienvenido',
  beeText1: 'Bzz... ¿Quieres que te ayude a crear algunas tareas?',
  beeText2:
    'Echa un vistazo al campo de texto a continuación. te dará una pista sobre cómo empezar',
  beeText3: 'Bzzz... Soy una abeja ocupada, pero puedo ayudarte a crear algunas tareas',
  task: 'Tarea',
  taskExample1: 'Limpiar el baño',
  taskExample2: 'Preparación de comidas',
  taskExample3: 'Ir al supermercado',
  taskExample4: 'Lavar la ropa',
}
